import { Link } from 'react-router-dom';
import { Fragment, useEffect, useMemo } from 'react';
import { LockOutlined } from '@mui/icons-material';
import { useSelector, useDispatch } from "react-redux";

import { showMessage } from '../../config.js';
import ModalWrapper from '../common/Modal/ModalWrapper';
import { toggleModal } from "../../reducers/modalReducer";
import ModuleCardMenus from '../ModuleCard/ModuleCardMenus.js';

export default function CoreWorkspaceButton({ buttonClass, linearProgress, permissionLevel, step, title, type, seeMore, howItWorks, handleSeeMore, handleHowItWorks, directors, directorsStats, company, moduleCertification,
	module, setTab, getFitInvestorFirms, scrollId, setModuleTab, setIsViewTwoMinuteReport, isReady = false, fitInvestorFirms, subscription, time, isBuy, price, information }) {
	const dispatch = useDispatch();
	const user = useSelector(state => state.user);

	const { strongCount, mediumCount, lowCount } = useMemo(() => {
		if (!fitInvestorFirms?.length) return { strongCount: 0, mediumCount: 0, lowCount: 0 };

		return fitInvestorFirms.reduce((acc, investor) => {
			const score = investor.fitScorePercentage;
			if (score >= 83) acc.strongCount++;
			else if (score >= 66.6 && score < 83) acc.mediumCount++;
			else if (score < 66.6) acc.lowCount++;
			return acc;
		}, { strongCount: 0, mediumCount: 0, lowCount: 0 });
	}, [fitInvestorFirms]);

	const handleLinkModuleTab = (type, module) => {
		if ((type.startsWith('two-minute-') && !company['freeModules']) || (company['freeModules'] && !company['freeModules'][type])) {
			return `#`;
		}

		if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
			if (['software-development', 'esg', 'warranty-disclosure', 'directors-questionnaire'].includes(type) && !company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) return '#';
		}
		if (permissionLevel == 'ALL') {
			if (user?.['role'] == 'Guest' && (type == `two-minute-test-${company?.['testType']}` || type == "kpi-report")) return '#';
			if (type == 'directors-questionnaire') return '#';
			return `#${type}`;
		}
	};

	useEffect(() => {
		if (type === "kpi-report") {
			setIsViewTwoMinuteReport(false);
		}
	}, [type]);

	const setReportTab = async (type) => {
		if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD')) {
			showMessage('You have Dashboard access only!');
			return;
		};

		if (type == 'investor-lead') {
			getFitInvestorFirms();
			return;
		}

		setTab(type + '-report')
	};

	const showPercent = (value, type, title) => {
		let color;
		if (value > 0) {
			if (type == 'Module Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
			else if (type == 'Module Complete') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
		}
		else color = 'c28'
		return <h4 className={`${color} fs2rem lh1 ${title === "InvestorMatch" ? 'mr0rem' : 'mr2rem'}`}>{value || 0}%<br /><span className={`${value > 0 ? 'c15 ' : 'c28 '} fs0-75rem w4rem db fw300`}>{type}</span></h4>
	};

	const navigateSection = async (type, sectionNo) => {
		if (user?.['role'] == 'Guest') {
			dispatch(toggleModal({ open: 'noRegistrationReport' }))
			return;
		};

		if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
			showMessage(`You have ${permissionLevel} access only!`);
			return;
		};

		if (['software-development', 'esg', 'warranty-disclosure', 'directors-questionnaire'].includes(type)) {
			// CHECK EXPANSION PACK PERMISSIONS FOR MEMBERS
			const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`
			if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
				if (!(company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']])) {
					showMessage(message);
					return;
				}
			}
			// CHECK EXPANSION PACK PERMISSIONS FOR ADVISORS/INVESTORS
			if ((user['role'] == "Advisor" || user['role'] == 'Investor') && company['creatorId']['_id'] != user['_id']) {
				if (!(company?.[user['role'] == "Investor" ? 'investors' : 'advisors']?.[user['_id']]?.['modules']?.[module?.['sections']?.[0]?.['sectionNo']])) {
					showMessage(message);
					return;
				}
			}
		};

		await setTab(type);
		setTimeout(() => {
			let element = document.getElementById(sectionNo);
			if (element) element.scrollIntoView({ behavior: 'instant' }, true);
		}, 1000);
	};

	const moduleTooltip = (sections, module) => {
		return (
			<div className='cp module-tooltip-box'>
				{/* <div className='hover-list'>
					<img src={require('../../../images/hover-list-icon.png')} className="pa" alt="list-img" />
				</div> */}

				{sections?.length > 0 &&
					<span className={`tooltip-area ${(module?.heading === "Investor Match" || (sections?.length && sections?.length < 8))
						? 'tooltip-top-important'
						: ''
						}`}
					>
						{sections.map((section, idx) => {
							if (!section.stats) section.stats = module['sections'][0]['stats'];
							const completeness = section.stats.completionPercent;

							let riskColour;
							if (module.type === "repository" || section.stats.riskPercent < 38) riskColour = 7;
							else if (section.stats.riskPercent > 62) riskColour = 9;
							else riskColour = 8;

							let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";

							let colorChange = false;
							if (module['type'] == "warranty-disclosure") {
								if (section?.questions && section?.questions.length > 0) section?.questions.map(question => {
									if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
										colorChange = true;
										return;
									}
								})
							}
							return <button key={idx} onClick={() => navigateSection(type, section['sectionNo'])} style={{ background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` }} data-scroll-to={section['sectionNo']} className="overlay-box tal w100 tac cp c3-hover"><span>{section['sectionName']}</span></button>
						})}
					</span>
				}
			</div>
		)
	};

	const directorModuleTooltip = (items) => {
		return (
			<div className='module-tooltip-box'>
				{items.length > 0 &&
					<span className="tooltip-area">
						{items.map((item, idx) => {
							let completeness = (company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['completionPercent'] ? company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['completionPercent'] : 0);
							let riskColour;
							if (company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['riskPercent'] && company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['riskPercent'] < 38) riskColour = 7;
							else if (company['moduleStats']?.[`directors-questionnaire_${item?._id}`]['stats']?.['riskPercent'] && company['moduleStats']?.[`directors-questionnaire_${item?._id}`]['stats']?.['riskPercent'] > 62) riskColour = 9;
							else riskColour = 8;

							let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";

							return <div key={idx} style={{ background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` }} className="overlay-box tal"><span>{item['name']}</span></div>
						})}
					</span>
				}
			</div>
		)
	};

	function transformSubFoldersToSections(subFolders) {
		return Object.values(subFolders).map((item, index) => {
			return {
				_id: item.sectionId || `${item.sectionNo}-${index}`, // fallback id
				sectionNo: item.sectionNo,
				sectionName: item.sectionName,
				type: "Workflow Sections",
				subFolders: {}, // since these contain questions instead
				questions: item.questions || [],
				stats: item.stats || {},
				isDefault: false,
				isSection: true,
				isPrompt: false,
				updatedAt: new Date().toISOString(),
			};
		});
	}

	const tranformedData = (module) => {
		if (module['type'] && module['type'] === "investor-lead" && module['sections'] && module['sections'][0] && module['sections'][0]['subFolders']) {
			return {
				...module,
				sections: transformSubFoldersToSections(module['sections'][0]['subFolders']),
			}
		}
		return module
	}

	return (
		<Fragment>
			<div id={scrollId} className={`${buttonClass} ${user?.['role'] == 'Guest' ? 'bo3' : 'bo7'}  w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb`}>
				<ModuleCardMenus
					menus={module['menus']}
					module={tranformedData(module)}
					onNavigateSection={navigateSection}
					setReportTab={setReportTab}
					type={module?.['title'] || module?.['heading'] || ''}
					company={company}
					seeMore={seeMore}
					howItWorks={howItWorks}
				/>
				<Link to={handleLinkModuleTab(type, module)} onClick={() => setModuleTab(setTab, type, module)} className="cp w100 h100" style={{ minHeight: '133px' }}>
					<div className="cp ttc pr fs1rem fw500 c15 lh2 df aic zi1 w100">
						<div className='df fw500 fs1-25rem c15 aifs w100'>
							<div className='df aic cp w100'>
								<i className='icon-diligenstia mr1rem'>
									<img className="w40px h40px" src={require(`../../../images/advisor-dashboard/logo-advisor.svg`)} alt="" />
								</i>
								<p className='fs1rem fw500 c15 lh2 title-box-feature w100'>
									{
										company?.['subscription'] == 'Pro' &&
										(type == 'repository' || type == `business-audit-${company?.['testType']}` || type == 'warranty-disclosure' || type.includes("directors-questionnaire")) &&
										<button onClick={() => document.getElementById('dashboard-required-star').scrollIntoView({ behavior: "smooth" })} type='button' className='cp bg1 icon'>
											<img src={require('../../../images/landingpage/gold-star-icon.png')} alt="star-img" />
										</button>
									}
									{title === "InvestorMatch" ? <div>
										<p className='c15 fs11px fw400'>OneForm</p>
										<span className='cp c4-hover'>Investor<span className='c4'>Match</span></span>
									</div> : <p className='df aic jcsb w100'>
										<span className='cp c4-hover'>{title}</span>
										<span className='c59 ttu'>{subscription}</span>
									</p>}

								</p>
							</div>
						</div>
					</div>
					{company?.['subscription'] == 'Pro' && type == "unaudited-certification" && linearProgress &&
						<div className="bottom-certification w70 mt1rem df jcfs fww pr" style={{ top: '16px' }}>
							<img className="w100" src={require(`../../../images/advisor-dashboard/banner-certificate-bottom.png`)} alt="" />
							<div className="progress-dashboard-horizantal" role="progressbar" id="progressBar">
								<div className="progress-bar progress-bar-striped progress-bar-animated" id="innerBar" style={{ width: `${linearProgress}%` }}></div>
							</div>
						</div>
					}
					{type.includes("directors-questionnaire") &&
						<span className='cp step-box text-gradient' style={{ fontSize: '12px', right: '50px' }}>({directors.length}) - Directors</span>
					}
					{(user['role'] == 'Guest' && step) && <span className='step-box'>Step {step}</span>}
					{(time && !module.stats.completionPercent) ? <><div className='df fdc aife' style={{ position: 'absolute', right: '10px', bottom: '10px' }}  >
						{
							time && <div className='df aic'>
								<img src={require('../../../images/dashboard/stopwatch.svg')} style={{ width: '14px', height: '14px' }} />
								<span style={{ fontSize: '14px' }}>{time}</span>
							</div>
						}
					</div></> : moduleCertification && <>
						{(title === "InvestorMatch" && !module.stats.completionPercent) ? <></> : (moduleCertification == 'None') && <div className="ribbon ribbon-bottom-right grey"><img className="mr0-5rem" style={{ width: '70px' }} src={require(`../../../images/insufficient-score.png`)} alt="" /></div>}
						{moduleCertification == 'Bronze' && <div className="trophy-cup ribbon ribbon-bottom-right bronze"><img className="h4rem" src={require(`../../../images/bronze-cup.png`)} alt="" /></div>}
						{moduleCertification == 'Silver' && <div className="trophy-cup ribbon ribbon-bottom-right silver"><img className="h4rem" src={require(`../../../images/silver-cup.png`)} alt="" /></div>}
						{moduleCertification == 'Gold' && <div className="trophy-cup ribbon ribbon-bottom-right gold"><img className="h4rem" src={require(`../../../images/gold-cup.png`)} alt="" /></div>}
					</>}
					{(information && !module.stats.completionPercent) ? <><span className="bottom-features df jcsb aife mt1rem tal pa c15 op50" style={{ bottom: '15px' }}>
						<p className='w70 tal c15 pr' style={{ fontSize: '0.75rem' }}>{information}</p>
					</span></> : type == "directors-questionnaire" && directorsStats
						? <span className="tooltip-area style-two pa df aic jcsb w90">
							<div className="percentage-area df jcc aic mb1rem">
								{showPercent(directorsStats?.completionPercent || 0, 'Module Complete', title)}
								{showPercent(directorsStats?.riskPercent || 0, 'Module Risk', title)}
							</div>
						</span>
						: module?.stats && <>{
							type !== "kpi-report" && (
								<>
									{
										(title === "InvestorMatch" && !module.stats.completionPercent) ? <p className='c70'>One application from to match <br></br>against our investor database</p> :
											<span className="cp tooltip-area style-two pa df aic jcsb w90" style={type.includes("directors-questionnaire") ? { bottom: "30px" } : {}}>
												<div className={`percentage-area df jcc aic ${user['role'] == 'Guest' && ' mb1rem'}`}>
													{title === "InvestorMatch" ? <>
														<div className='df aic'>
															<div className='df fdc aifs jcfs px1rem '>
																<p className={`${strongCount > 0 ? 'c34' : 'c28'} fs2rem fw600 lh1 w100 tal`}>{strongCount}</p>
																<p className='c15 fs0-75rem w4rem db fw300' style={{ lineHeight: '1.2' }}>Strong <br></br>Matches</p>
															</div>
															<div className='df fdc aifs jcfs p0rem'>
																<p className={`${mediumCount > 0 ? 'c75' : 'c28'} fs2rem fw600 lh1 w100 tal`}>{mediumCount}</p>
																<p className='c15 fs0-75rem w4rem db fw300' style={{ lineHeight: '1.2' }}>Medium <br></br>Matches</p>
															</div>
														</div>
													</> : <>
														{showPercent(module.stats.completionPercent || 0, 'Module Complete', title)}
														{(type != 'repository' && type != 'investor-lead') && showPercent(module.stats.riskPercent || 0, 'Module Risk', title)}
													</>}
												</div>
											</span>
									}
								</>
							)}
						</>}
					{type == "kpi-report" && <>
						<span className="bottom-features df jcsb aife mt1rem tal pa c15 op50" style={{ bottom: '15px' }}>
							<p className='w100 tal c15 pr' style={{ fontSize: '0.75rem' }}>AI generated & bespoked to<br />your company</p>
						</span>
						{isReady && <span className='br50px c1 pa' style={{ background: '#15D757', right: '15px', bottom: '15px', padding: '2px 10px' }}>
							<img className='mr0-5rem' src={require('../../../images/dashboard/whiteCheck.png')} alt="Ready" />
							Ready
						</span>}
					</>
					}
				</Link>
				{module
					? (type !== "kpi-report") && moduleTooltip(module['expansionPack'] ? Object.values(module['sections'][0]['subFolders']) : module.sections, module)
					: title == "Directors Questionnaire" && directorModuleTooltip(directors)
				}

			</div>

			{/* No Registration Report Popup */}
			<ModalWrapper modalType={"noRegistrationReport"} modalCardClasses="maw800px">
				<>
					<h2 className="c15 fw600 tac w100">Registration</h2>
					<div className='df fdc jcc my1rem'>
						<div className='tac'>
							<p className='my0-5rem c15 op70 fs14px'>To view or store/print your company reports, <br /> you need to register (no credit card required).</p>
						</div>
						<div className='df jcc mt1rem'>
							<Link to='/register' onClick={() => dispatch(toggleModal({ open: '' }))} className="shadow bsbb jcc df fdc aic fw500  px1rem c1 bg4 br19px cp" style={{ width: '44%', paddingTop: '4px', paddingBottom: '4px' }}>
								<span>Register for FREE</span>
								<span className="fw400 c21 df fdc" style={{ marginTop: "-2px", fontSize: '10px', lineHeight: '15px', fontStyle: 'italic' }}>No credit card required</span>
							</Link>
						</div>
						<p className='mt1-5rem c15 op70 fs11px fsi df aic tac lh1'> <LockOutlined style={{ color: "#4A67FF", fontSize: '12px', marginRight: '4px' }} /> Get access to more features. Store your test results plus FREE bonus KPI Report, all bespoked by AI to your company.</p>
					</div>
				</>
			</ModalWrapper>

		</Fragment>
	);
}